var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20C16.88 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18C20 19.1 19.12 20 18 20Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20C24.88 20 24 19.1 24 18C24 16.9 24.9 16 26 16C27.1 16 28 16.9 28 18C28 19.1 27.12 20 26 20Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C8.88 20 8 19.1 8 18C8 16.9 8.9 16 10 16C11.1 16 12 16.9 12 18C12 19.1 11.12 20 10 20Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.74bbdd964d23f821b79a8cea8a60e76f.svg";
export { ForwardRef as ReactComponent };